import { defineEndpoints } from '../config/define-endpoints';

type PriceChartParams = {
    vsCurrency: string;
    from: number;
    to: number;
    coingeckoApiKey?: string;
};

type GetPriceChartRequest = {
    vsCurrency: string;
    from: number;
    to: number;
    slug: string;
    coingeckoApiKey: string;
};

type GetPriceChartResponse = {
    prices: any[];
    market_caps: any[];
    total_volumes: any[];
};
const COIN_GECKO_ENDPOINTS = defineEndpoints(template => ({
    GET: {
        PRICE_CHART: template('/coins/{slug}/market_chart/range'),
    },
}));

export type { GetPriceChartRequest, GetPriceChartResponse, PriceChartParams };
export { COIN_GECKO_ENDPOINTS };
